import { FC, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Loader } from 'src/components/Loader/Loader';
import { Page } from 'src/components/Page/Page';
import { RoutePath } from 'src/routes/types';
import { getIsMobile } from 'src/store/agent/selectors';
import { navigationActions } from 'src/store/navigation/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { getUserState } from 'src/store/user/selectors';

import classes from './MainPage.module.scss';
import { Navigation } from './Navigation/Navigation';

export const MainPage: FC = () => {
  const dispatch = useAppDispatch();
  const isMobile = useSelector(getIsMobile);
  const { loading } = useSelector(getUserState);

  useEffect(() => {
    dispatch(navigationActions.setSegments([RoutePath.Main]));
  }, [dispatch]);

  const content = useMemo(() => {
    if (loading) {
      return (
        <div className={classes.fallback}>
          <Loader />
        </div>
      );
    }

    if (isMobile) return <Navigation />;

    return null;
  }, [isMobile, loading]);

  return <Page testId='main'>{content}</Page>;
};

export default MainPage;
